/*------------------------------------------------------------------
Accordion State
------------------------------------------------------------------*/

const getState = (data, index) => {
  let state = null;
  switch (data) {
    case 'first-open':
      state = index == 0;
      break;
    case 'all-open':
      state = 1;
      break;
    default:
      state = 0;
      break;
  }
  return state;
};

/*------------------------------------------------------------------
Accordion Setup
------------------------------------------------------------------*/

Promise.all([import('accordions')]).then(_ref => {
  let [moduleAccordion] = _ref;
  const Accordion = moduleAccordion.default;
  DomObserver.observe('.js-default-accordion', blocks => {
    blocks.forEach(block => {
      const items = block.querySelectorAll('.js-default-accordion__item');
      const data = block.getAttribute('data-state');
      const Controller = new Accordion(block, {
        multiple: data == 'all-open'
      });
      for (let i = 0; i < items.length; i++) {
        // Save the item
        const item = items[i];
        Controller.add(item, {
          active: getState(data, i),
          trigger: item.querySelector('.js-default-accordion__trigger'),
          target: item.querySelector('.js-default-accordion__target')
        });
      }
    });
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});